// @flow
import React from 'react';
import Lock from '@material-ui/icons/Lock';

type Props = {
    title: string,
    body: string,
    profileImage: string
};

const SessionNoteCard = ({ title, body, profileImage }: Props) => {
    let profileImageUrl =
        'https://static.trainheroic.com/images/ExerciseCommentIcon.png';
    if (profileImage) {
        profileImageUrl = profileImage;
    }

    return (
        <div className="session-note-card">
            <img className="circle-profile-img " src={profileImageUrl} alt="" />
            <div className="session-note">
                <div className="session-note-title">
                    <div>
                        {title} <Lock className="lock-icon" />
                    </div>
                </div>
                <span>{body}</span>
            </div>
        </div>
    );
};

export default SessionNoteCard;



// WEBPACK FOOTER //
// ./src/view/calendar/components/SessionNoteCard.jsx